"use strict;"

var _ = require('lodash');
exports["home"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '')
  }
  with(obj) {

    if (parseInt(show_branding)) {;
      __p += '\n\t<div class="branding-container">\n\t\t';
      if (branding_image_600x300) {;
        __p += '\n\t\t\t<img src="' + ((__t = (branding_image_600x300)) == null ? '' : __t) + '">\n\t\t';
      };
      __p += '\n\t</div>\n';
    };
    __p += '\n<div class="countdown-container">\n\t';
    if (parseInt(show_copy_text)) {;
      __p += '\n\t\t<div class="intro-text">' + ((__t = (copy_text)) == null ? '' : __t) + '</div>\n\t';
    };
    __p += '\n\t\n\t<div class="countdown-time">\n\t\t';
    if (parseInt(show_month)) {;
      __p += '\n\t\t\t<div class="countdown-unit countdown-months">\n\t\t\t\t<span class="countdown-unit-cell">\n\t\t\t\t\t<div class="countdown-value">' + ((__t = (time_months < 10 ? '0' + time_months : time_months)) == null ? '' : __t) + '</div>\n\t\t\t\t\t<br>\n\t\t\t\t\t';
      if (parseInt(show_labels)) {;
        __p += '<span class="countdown-unit-label"> ' + ((__t = ((time_months === 1 ? 'Month' : 'Months'))) == null ? '' : __t) + '</span>';
      };
      __p += '\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class="colon">\n\t\t\t\t<div class="text">:</div>\n\t\t\t</div>\n\t\t';
    };
    __p += '\n\t\t';
    if (parseInt(show_days)) {;
      __p += '\n\t\t\t<div class="countdown-unit countdown-days">\n\t\t\t\t<span class="countdown-unit-cell">\n\t\t\t\t\t<div class="countdown-value">' + ((__t = (time_days < 10 ? '0' + time_days : time_days)) == null ? '' : __t) + '</div>\n\t\t\t\t\t<br>\n\t\t\t\t\t';
      if (parseInt(show_labels)) {;
        __p += '<span class="countdown-unit-label"> ' + ((__t = ((time_days === 1 ? 'Day' : 'Days'))) == null ? '' : __t) + '</span>';
      };
      __p += '\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class="colon">\n\t\t\t\t<div class="text">:</div>\n\t\t\t</div>\n\t\t';
    };
    __p += '\n\t\t';
    if (parseInt(show_hours)) {;
      __p += '\t\n\t\t\t<div class="countdown-unit countdown-hours">\n\t\t\t\t<span class="countdown-unit-cell">\n\t\t\t\t\t<div class="countdown-value">' + ((__t = (time_hours < 10 ? '0' + time_hours : time_hours)) == null ? '' : __t) + '</div>\n\t\t\t\t\t<br>\n\t\t\t\t\t';
      if (parseInt(show_labels)) {;
        __p += '<span class="countdown-unit-label"> ' + ((__t = ((time_hours === 1 ? 'Hour' : 'Hours'))) == null ? '' : __t) + '</span>';
      };
      __p += '\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class="colon">\n\t\t\t\t<div class="text">:</div>\n\t\t\t</div>\n\t\t';
    };
    __p += '\n\t\t';
    if (parseInt(show_minutes)) {;
      __p += '\n\t\t\t<div class="countdown-unit countdown-minutes">\n\t\t\t\t<span class="countdown-unit-cell">\n\t\t\t\t\t<div class="countdown-value">' + ((__t = (time_minutes < 10 ? '0' + time_minutes : time_minutes)) == null ? '' : __t) + '</div>\n\t\t\t\t\t<br>\n\t\t\t\t\t';
      if (parseInt(show_labels)) {;
        __p += '<span class="countdown-unit-label"> ' + ((__t = ((time_minutes === 1 ? 'Min' : 'Mins'))) == null ? '' : __t) + '</span>';
      };
      __p += '\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class="colon">\n\t\t\t\t<div class="text">:</div>\n\t\t\t</div>\n\t\t';
    };
    __p += '\n\t\t';
    if (parseInt(show_seconds)) {;
      __p += '\n\t\t\t<div class="countdown-unit countdown-seconds last">\n\t\t\t\t<span class="countdown-unit-cell">\n\t\t\t\t\t<div class="countdown-value">' + ((__t = (time_seconds < 10 ? '0' + time_seconds : time_seconds)) == null ? '' : __t) + '</div>\n\t\t\t\t\t<br>\n\t\t\t\t\t';
      if (parseInt(show_labels)) {;
        __p += '<span class="countdown-unit-label"> ' + ((__t = ((time_seconds === 1 ? 'Sec' : 'Secs'))) == null ? '' : __t) + '</span>';
      };
      __p += '\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t';
    };
    __p += '\n\t</div>\n\n</div>';

  }
  return __p
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/tswdg-countdown/build/templates.js
// module id = 269
// module chunks = 0